import { memo, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PulseLoader from "react-spinners/PulseLoader";

const DataTableVideos = memo((props) => {
    const { fixedHeader, expandableRows, columns, userItems, customStyles, pending, ExpandedComponent, handleEditAndViewVideo, handleRemoveVideo, handleArchiveVideo, videoDataTableGetVersions, videoStatus, videosTableVisibility, confirmDialogAction, setConfirmDialogAction, showConfirmationButton } = props;

    const expandedRowsComponent = useCallback(
        (data) => ExpandedComponent({ ...data, handleEditAndViewVideo, handleRemoveVideo, handleArchiveVideo, videoDataTableGetVersions, videoStatus,videosTableVisibility, confirmDialogAction, setConfirmDialogAction, showConfirmationButton }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <DataTable
        fixedHeader={fixedHeader || false}
        fixedHeaderScrollHeight="200px"
            columns={columns}
            data={userItems}
            customStyles={customStyles}
            progressPending={pending}
            progressComponent={
                <p className="user_datatable_loading">
                    Buscando Informações...{" "}
                    <PulseLoader
                        color="#1361A4"
                        className="user_datatable_loader"
                    />
                </p>
            }
            highlightOnHover
            noDataComponent={
                <div className="user_datatable_loading">
                    <div>
                        <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                id="Vector"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M22.3805 15.2341C23.0181 15.2341 23.3823 14.5064 23 13.9961L21 10.9961C20.5375 10.2277 19.7062 9.7578 18.8094 9.7578H7.62658C7.07618 9.7578 6.56235 10.0334 6.25792 10.492L4.5667 13.0393C4.56552 13.0411 4.5668 13.0435 4.56893 13.0435C4.57107 13.0435 4.57234 13.0459 4.57117 13.0476L3.85 14.1388C3.53979 14.6081 3.87636 15.234 4.43896 15.234H7.75886C9.13473 15.234 10.2013 16.4939 11.1434 17.4966C11.7356 18.1268 12.5724 18.5197 13.5001 18.5197C14.4626 18.5197 15.3275 18.0967 15.9225 17.4245C16.7988 16.4347 17.8217 15.234 19.1437 15.234L22.3805 15.2341ZM25.8324 14.2286C26.2678 14.8843 26.5 15.654 26.5 16.4411V19.9961C26.5 22.2052 24.7091 23.9961 22.5 23.9961H4.5C2.29086 23.9961 0.5 22.2052 0.5 19.9961V16.4412C0.5 15.654 0.732258 14.8843 1.16768 14.2285L4.40363 9.35504C5.14488 8.23868 6.3959 7.56766 7.73594 7.56766H19.2644C20.6045 7.56766 21.8556 8.23874 22.5968 9.35518L25.8324 14.2286ZM9.87597 19.3045C8.83173 18.3534 7.61948 17.4246 6.20703 17.4246H4.85678C3.64704 17.4246 2.66636 18.4053 2.66636 19.6151C2.66636 20.8248 3.64704 21.8055 4.85678 21.8055H22.1423C23.352 21.8055 24.3327 20.8248 24.3327 19.6151C24.3327 18.4053 23.352 17.4246 22.1423 17.4246H20.7921C19.3796 17.4246 18.1673 18.3535 17.1229 19.3044C16.1631 20.1784 14.8925 20.7103 13.4991 20.7103C12.1056 20.7103 10.8355 20.1784 9.87597 19.3045ZM14.5832 4.29368C14.5832 4.89195 14.0982 5.37695 13.4999 5.37695C12.9016 5.37695 12.4166 4.89195 12.4166 4.29368V2.07936C12.4166 1.48109 12.9016 0.996094 13.4999 0.996094C14.0982 0.996094 14.5832 1.48109 14.5832 2.07936V4.29368ZM20.4458 5.20593C20.068 5.67893 19.3767 5.7525 18.9077 5.36962C18.4458 4.99246 18.3736 4.31374 18.7458 3.84781L20.0124 2.26227C20.3903 1.78928 21.0816 1.71571 21.5505 2.09859C22.0125 2.47575 22.0847 3.15447 21.7125 3.6204L20.4458 5.20593ZM8.25399 3.84781C8.6262 4.31373 8.55397 4.99246 8.09204 5.36962C7.62309 5.7525 6.9318 5.67893 6.55393 5.20593L5.2873 3.6204C4.91508 3.15447 4.98731 2.47575 5.44925 2.09859C5.91819 1.71571 6.60949 1.78928 6.98735 2.26227L8.25399 3.84781Z"
                                fill="#344054"
                            />
                        </svg>
                    </div>
                    <p className="datatable_nodata_text">Não encontramos registros para os dados informados.</p>
                </div>
            }
            defaultSortFieldId={5}
            defaultSortAsc={true}
            sortIcon={<ArrowDropDownIcon color="#1361A4" />}
            expandableRows={expandableRows}
            expandableRowsComponent={expandedRowsComponent}
        ></DataTable>
    );
});

DataTableVideos.displayName= "DataTableVideos"

export default DataTableVideos;